import { render, staticRenderFns } from "./Statement-template-list.vue?vue&type=template&id=18d114be"
import script from "./Statement-template-list.vue?vue&type=script&lang=js"
export * from "./Statement-template-list.vue?vue&type=script&lang=js"
import style0 from "./Statement-template-list.vue?vue&type=style&index=0&id=18d114be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports